import React from "react";
import { GetEntryAPI, UpdateAPI, CreateAPI } from "../services";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { LanguageLoader } from '../assets/languages';
import Fields from "../components/features/Fields";
import {ValidateField, IsRequiredEmpty} from "../components/utils/validation";
import { Toastify, RefactorDropdown } from "../components/utils";
import FAQ from "../components/features/FAQ";
import NotFound from "./NotFound";

const EditView = () =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const settings = useSelector((state) => state.settings);
	const current_user = useSelector((state) => state.current_user);
	const [errors, setErrors] = useState({});
	const [isBusy, SetBusy] = useState(false);
	const [dataEntry, SetDataEntry] = useState({});
	const dataEntryRef = useRef(dataEntry);
	const {module, id} = useParams();
	const location = useLocation();
	const isDuplicate = (location.state && location.state.isDuplicate ) ? true : false; 
	
	const subpanel = (location.state && location.state.subpanel && location.state.parent) ? true : false;
	const definition = subpanel ? settings.definitions.subpanels[module] : settings.definitions.modules[module];
	const fields = definition ? definition['fields'] : [];
	const navigate = useNavigate();
	const disableFieldsPerModuleEdit =
		(settings.disable_fields_per_module &&
		settings.disable_fields_per_module[module] &&
		Array.isArray(settings.disable_fields_per_module[module].edit))
			? settings.disable_fields_per_module[module].edit
			: [];

	useEffect(() =>
	{
		dataEntryRef.current = dataEntry;
	}, [dataEntry]);

	useEffect(() =>
	{
		getEntry();
	// eslint-disable-next-line
	}, [id, module]);

	const getEntry = async () =>
	{
		try
		{
			if (id && fields)
			{
				var selectedFields = ['id'];
				for(let field in fields)
				{
					selectedFields.push(field);
					if(fields[field]['related_to'] && fields[field]['related_to'] !== '')
					{
						selectedFields.push(fields[field]['related_to']);
					}
				}
				const data = { id:id, module:module, selected_fields:selectedFields }
				const APIResponse = await GetEntryAPI(data);
				if (APIResponse)
				{
					if(APIResponse['permissions'])
					{
						if(APIResponse['permissions']['Edit'] == false)
						{
							navigate(`/list/${module}`);
							return;
						}
					}
					SetDataEntry(APIResponse[0]);
				}
			}
			else
			{
				SetDataEntry(DefaultData());
			}
		}
		catch (ex){}
	}

	const DefaultData = () => 
	{
		let data = {};
		for(let field in fields)
		{
			if(!settings.disable_fields.includes(field) && !disableFieldsPerModuleEdit.includes(field))
			{
				if(fields[field].default)
				{
					data[field] = fields[field].default;
				}
				else if(fields[field].type === 'enum' && fields[field].options && Object.keys(fields[field].options).length)
				{
					fields[field].options = RefactorDropdown(fields[field].options);
					// Don't set default to "0" (blank option) - leave it undefined
					const firstKey = Object.keys(fields[field].options)[0];
					if(firstKey !== "0" && firstKey !== 0)
					{
						data[field] = firstKey;
					}
					// If first key is "0", don't set it - field will be undefined
				}
			}
		}
		return data;
	};

	const HandleFieldChange = (field, value) =>
	{
		const fieldDef = fields[field];
		const prevVal = dataEntryRef.current[field];
		SetDataEntry((prev) => {
			const next = {...prev, [field]: value};
			dataEntryRef.current = next;
			return next;
		});
		if(fieldDef && fieldDef.validation && fieldDef.validation.includes('required'))
		{
			const wasFilled = !IsRequiredEmpty(prevVal, fieldDef);
			const isEmptyNow = IsRequiredEmpty(value, fieldDef);
			if(isEmptyNow && wasFilled)
			{
				setErrors((prevErrors) => ({...prevErrors, [field]: [language.ERROR.IS_REQUIRED]}));
			}
			else if(!isEmptyNow)
			{
				setErrors((prevErrors) => {
					if(!prevErrors[field])
					{
						return prevErrors;
					}
					const updated = {...prevErrors};
					delete updated[field];
					return updated;
				});
			}
		}
	};

	const ValidateForm = () => 
	{
		const errors = ValidateField(dataEntryRef.current, fields);
		if (Object.keys(errors).length === 0)
		{
			return true;
		}
		else
		{
			setErrors(errors);
		}
	};

	const PrepareAPIData = (entry) =>
	{
		const dataEntry = {...entry};
		if(Array.isArray(dataEntry.lineitems))
		{
			dataEntry.lineitems = dataEntry.lineitems.map((item) => ({...item}));
		}
		if(dataEntry.date_entered)
		{
			delete dataEntry.date_entered;
		}
		if(dataEntry.date_modified)
		{
			delete dataEntry.date_modified;
		}
		for(const field in dataEntry)
		{
			if(fields[field] && fields[field]['related_to'] && fields[field]['related_to'].length > 0)
			{
				if(dataEntry[fields[field]['related_to']])
				{
					delete dataEntry[fields[field]['related_to']];
				}
			}
			else if(field === 'lineitems')
			{
				for(const index in dataEntry[field])
				{
					delete dataEntry[field][index].name;
					delete dataEntry[field][index].currency_symbol;
				}
			}
			// Handle enum/multienum fields with "0" value (blank selections)
			else if(fields[field] && (fields[field].type === 'enum' || fields[field].type === 'multienum'))
			{
				const fieldValue = dataEntry[field];
				const isBlank = fieldValue === "0" || fieldValue === 0 || fieldValue === undefined || fieldValue === null;
				
				if(isBlank)
				{
					// In edit mode (id exists), send empty string to clear the field
					// In create mode, omit the field
					if(id)
					{
						dataEntry[field] = "";
					}
					else
					{
						delete dataEntry[field];
					}
				}
				// For multienum, also check if array contains only "0" or is empty
				else if(fields[field].type === 'multienum' && Array.isArray(fieldValue))
				{
					const filteredArray = fieldValue.filter(v => v !== "0" && v !== 0);
					if(filteredArray.length === 0)
					{
						// In edit mode, send empty array to clear
						// In create mode, omit the field
						if(id)
						{
							dataEntry[field] = [];
						}
						else
						{
							delete dataEntry[field];
						}
					}
					else
					{
						dataEntry[field] = filteredArray;
					}
				}
			}
		}
		return dataEntry;
	}

	const DoSave = async () =>
	{
		if (isBusy)
		{
			return;
		}
		if (ValidateForm())
		{
			SetBusy(true);
			try
			{
				let APIResponse;
				let data = PrepareAPIData(dataEntryRef.current);
				data["is_duplicate"] = isDuplicate; 
				if(!subpanel)
				{
					if(id)
					{
						APIResponse = await UpdateAPI(data, module, id);
					}
					else
					{
						if(!current_user.is_partner)
						{
							data["account_id"] = current_user.account.id;
						}
						APIResponse = await CreateAPI(data, module);
					}
				}
				else if(location.state.parent && location.state.parent.module && location.state.parent.id)
				{
					if(!current_user.is_partner)
					{
						data['account_id'] = current_user.account.id;
					}
					const parentData = location.state.parent;
					data["parent_type"] = parentData.module;
					data["parent_id"] = parentData.id; 
					APIResponse = await CreateAPI(data, definition.module);
				}
				if (APIResponse)
				{
					if(APIResponse['id'])
					{
						setTimeout(() =>
						{
							const redirectID = !subpanel ? APIResponse['id'] : location.state.parent.id;
							const redirectModule = !subpanel ? module : location.state.parent.module;
							window.location.replace('/detail/' + redirectModule + '/' + redirectID);
						}, 2000);
					}
					else
					{
						SetBusy(false);
						if(APIResponse['server_response_status'] !== 200 && APIResponse['server_response_description'].length && APIResponse['server_response_fields'])
						{
							Toastify(APIResponse['server_response_description'] +': '+ APIResponse['server_response_fields']);
						}
					}
				}
			}
			catch(ex){SetBusy(false);}
			finally{}
		}
	}
	return (!definition || (id && id.length && !definition.access.edit && !isDuplicate) || (!id && !definition.access.create)) ? <NotFound /> :
		<div className='wrapper'>
			<div className='title flex justify-between w-full'>
				<h6>{definition.label[preferences.language]}</h6>
				<div className="flex">
					{settings.FAQ.indexOf(module) !== -1 ? <FAQ/> : null}
					<Link onClick={() => navigate(-1)} className="btn btn-secondary">{language.CANCEL}</Link>
					<button onClick={DoSave} type='button' className="btn-primary" disabled={isBusy}>{isBusy ? <i className="fa fa-spin fa-spinner" style={{padding: '0 7.3px'}}></i> : language.SAVE}</button>
				</div>
			</div>
			<div className="flex flex-wrap">
				{Object.keys(fields).map((field, index) => {
					if(settings.disable_fields.includes(field) || disableFieldsPerModuleEdit.includes(field))
					{
						return null;
					}
					return <Fields
						key={index}
						subpanel={subpanel}
						module={module}
						field={field}
						value={dataEntry[field]}
						Callback={(value) => HandleFieldChange(field, value)}
						error={errors[field]}
						related_to={fields[field]['related_to'] ? dataEntry[fields[field]['related_to']] : null}
						related_module={fields[field]['module_field'] ? dataEntry[fields[field]['module_field']] : null}
					/>
				})}
			</div>
		</div>
}

export default EditView;
